import { Box, ClickAwayListener, styled, useMediaQuery } from '@mui/material'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import { colorPalette } from '~/constants/styles/colors'
import { useState } from 'react'
import { theme } from '~/lib/theme'

// 参考：https://mui.com/material-ui/react-tooltip/#customization
const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: colorPalette.white,
    color: colorPalette.text.primary,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(1.5),
  },
}))

export const LightTooltip = ({ children, title, ...props }: TooltipProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [open, setOpen] = useState(false)

  const handleClick = (e: React.MouseEvent) => {
    if (isMobile) {
      e.stopPropagation()
      setOpen((prev) => !prev)
    }
  }

  const handleClose = () => {
    if (isMobile) {
      setOpen(false)
    }
  }

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Box onClick={handleClick}>
        <StyledTooltip
          title={title}
          // モバイルのときだけopenを制御
          {...(isMobile && {
            open,
            disableHoverListener: true,
            disableFocusListener: true,
            disableTouchListener: true,
          })}
          {...props}
        >
          <Box component="span">{children}</Box>
        </StyledTooltip>
      </Box>
    </ClickAwayListener>
  )
}
